import styled from 'styled-components';
import { Row, Column, Button } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const BannerWrapper = styled(Row)`
  width: 100%;
  background: ${({ theme }) => theme.color.noir};
  padding: ${({ theme }) => theme.x2spacePx}px;
  color: ${({ theme }) => theme.color.white};
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  border-radius: 10px;
`;

export const Text = styled(Column)`
  p {
    ${({ theme }) => theme.typography.xSmall};
    margin-bottom: 0px;
    padding-right: ${({ theme }) => theme.x2spacePx}px;
    ${media.mdUp`
      margin-bottom: 0px;
      padding-right: 0px;
  `}
  }
`;

export const DismissButton = styled(Button)`
  width: 100%;
`;
